import { Progress, Statistic, theme } from "antd";
import { ReactElement, useMemo, useState } from "react";
import styled from "styled-components";

const { useToken } = theme;

export interface CountdownProps {
  endDate: Date | null;
  timeoutSeconds: number;
}

export default function Countdown({ endDate, timeoutSeconds }: CountdownProps): ReactElement {
  const { token } = useToken();

  const [remainingMs, setRemainingMs] = useState(0);
  const remainingSeconds = Math.min(timeoutSeconds, Math.round(remainingMs / 1000));

  const endDateTimestamp = useMemo(
    () => endDate?.getTime(),
    [endDate],
  );

  return (
    <>
      {
        endDateTimestamp &&
        <Statistic.Timer
          type="countdown"
          value={endDateTimestamp}
          onChange={value => value && setRemainingMs(value as number)}
          style={{ display: "none" }}
        />
      }
      <StyledProgress
        $disabled={!endDate}
        type="circle"
        status="active"
        percent={endDate ? Math.round((remainingMs / (timeoutSeconds * 1000)) * 100) : 0}
        format={() => endDate ? remainingSeconds : timeoutSeconds}
        size={token.controlHeightSM}
      />
    </>
  );
}

const StyledProgress = styled(Progress)<{ $disabled: boolean }>`
  &&& .ant-progress-text {
    color: ${p => p.$disabled && p.theme.colorTextDisabled};
  }
`;
